import { Component } from 'react'
import * as moment from 'moment'
import * as styles from 'styles/molecules/tables/AccountsDetailsHeader.css'
import Table2 from 'components/molecules/tables/Table2'
import { AccountType, DetailedAccount } from 'interfaces/accounts'
import { CreditAccount } from 'interfaces/credit'
import { createAccountSortingSelector } from 'helpers/accountHelpers'

// TODO: reuse `VALIDATORS` from `AccountsDetailsRow`

type AccountsDetailsHeaderProps = {
  type: AccountType | 'creditscore'
}

// TODO unify with TableHeaderMobile
class AccountsDetailsHeader extends Component<AccountsDetailsHeaderProps> {
  render () {
    const { type } = this.props
    const isDebts = type === 'debts'
    const isCreditscore = type === 'creditscore'

    return (
      <Table2.HeadRow>
        { /* debts | assets | creditscore */ }
        <Table2.HeadCell
          name='account_type'
          sorting={ (row: DetailedAccount | CreditAccount) => row.category.value }
        >
          <span className={ styles.visibleMediumUp }>Account</span> Type
        </Table2.HeadCell>

        { /* debts | assets | creditscore */ }
        <Table2.HeadCell
          name='account_name'
          sorting={ (row: DetailedAccount | CreditAccount) => row.name }
        >
          <span className={ styles.visibleMediumUp }>Account</span> Name
        </Table2.HeadCell>

        { /* debts */ }
        {
          isDebts && (
            <Table2.HeadCell
              name='rate'
              sorting={ createAccountSortingSelector((row) => row.rate) }
            >
              Interest rate
            </Table2.HeadCell>
          )
        }

        { /* debts | assets */ }
        {

          !isCreditscore && (
            <Table2.HeadCell
              name='amount'
              sorting={ (row: DetailedAccount) => row.link_status === 'unlinked' ? undefined : row.amount }
            >
              Balance
            </Table2.HeadCell>
          )
        }

        { /* debts */ }
        {
          isDebts && (
            <Table2.HeadCell
              name='due'
              sorting={ createAccountSortingSelector((row) => row.minimum_amount_due) }
            >
              Payment due
            </Table2.HeadCell>
          )
        }

        { /* debts */ }
        {
          isDebts && (
            <Table2.HeadCell
              name='due_date'
              sorting={ createAccountSortingSelector(({ due_date }) => due_date !== null ? moment(due_date).valueOf() : null) }
            >
              Due date
            </Table2.HeadCell>
          )
        }

        { /* creditscore */ }
        {
          isCreditscore && (
            <Table2.HeadCell
              name='condition'
              sorting={ (row: CreditAccount) => row.condition }
            >
              Condition
            </Table2.HeadCell>
          )
        }

        { /* creditscore */ }
        {
          isCreditscore && (
            <Table2.HeadCell
              name='balance'
              sorting={ (row: CreditAccount) => row.balance }
            >
              Balance
            </Table2.HeadCell>
          )
        }

        { /* creditscore */ }
        {
          isCreditscore && (
            <Table2.HeadCell
              name='pay_status'
              sorting={ (row: CreditAccount) => row.pay_status }
            >
              Pay status
            </Table2.HeadCell>
          )
        }

        { /* creditscore */ }
        {
          isCreditscore && (
            <Table2.HeadCell
              name='opened_at'
              sorting={ (row: CreditAccount) => moment(row.opened_at).valueOf() }
            >
              Date opened
            </Table2.HeadCell>
          )
        }

        { /* creditscore */ }
        {
          isCreditscore && (
            <Table2.HeadCell
              name='credit_limit'
              sorting={ (row: CreditAccount) => row.credit_limit }
            >
              Credit limit
            </Table2.HeadCell>
          )
        }

      </Table2.HeadRow>
    )
  }
}

export default AccountsDetailsHeader
